import _cloneDeep from 'lodash/cloneDeep';

export default {
  productCodesResults: (state) => _cloneDeep(state.productCodesResults),
};
